/* eslint-disable no-useless-escape */
export default function isValidEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}
